<template>
    <div class="chat">
        <div class="chat__group">
            <div v-for="(text, i) in cardData" :key="i" class="chat__item">
                <Card :text="text"/>
            </div>
            <div class="chat__item">
                <button id="getStarted" class="btn btn-carbon" @click="goToNext" @keyup.enter="goToNext">{{ $t('start') }}</button>
            </div>
        </div>
        <div class="chat__group" v-for="(question, index) in questionsList" :key="question.name">
            <template v-if="question.show">
                <div v-for="(text, i) in question.text" :key="i" class="chat__item">
                    <Card :text="text"/>
                </div>
                <Question
                    class="chat__item"
                    :id="`question-${index+1}`"
                    :question="question.question"
                    :questionId="question.id"
                    :options="question.options"
                    :help="question.help"
                    :answer="values[question.name]"
                    @optionSelected="handleOptionSelected($event, question.name)"
                />
            </template>
        </div>
        <ResultCard v-if="result"
            @showResult="scrollToResultCard"
            @calculateResult="jumpToPrevQuestion"/>
        <Loader v-if="loading"/>
        <div class="chat__bottom"></div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Card from '@/components/Card'
import Loader from '@/components/Loader'
import Question from '@/components/Question'
import ResultCard from '@/components/ResultCard'
import adobeTracking from '@/mixins/adobeTracking'

export default {
    name: 'Home',
    components: { Card, Loader, Question, ResultCard },
    data() {
        return {
            loading: false,
            chatBottom: null,
            chatScrollDuration: 1000
        }
    },
    mixins: [
        adobeTracking
    ],
    computed: {
        ...mapGetters('question', [
            'currentQuestion',
            'allQuestions',
            'values',
            'result'
        ]),
        cardData: {
            get() {
                return this.$t('landingPage:text', { returnObjects: true })
            }
        },
        lastQuestionIndex: {
            get() {
                return this.allQuestions.length - 1
            }
        },
        questionsList: {
            get() {
                const questions = this.allQuestions
                    .filter(question => question.show)
                    .map((option, id) => ({
                        id: id,
                        name: option.name,
                        text: this.relevantText(option),
                        question: this.$t(`questions:list.${option.questionLabel}.label`),
                        help: option.help ? this.$t(`questions:list.${option.questionLabel}.help`) : '',
                        options: this.$t(`questions:list.${option.questionLabel}.options`, { returnObjects: true }),
                        show: option.show
                    }))

                return questions
            }
        }
    },
    methods: {
        ...mapActions('question', [
            'setQuestion',
            'nextQuestion',
            'goBackToQuestion',
            'setCurrentChoice'
        ]),
        goToNext() {
            this.loading = true
            this.scrollToBottom()
            setTimeout(() => {
                this.setQuestion()
                this.loading = false
            }, this.chatScrollDuration)
            this.trackFormStart()
        },
        handleOptionSelected(value, name) {
            this.scrollToBottom()
            if (name === 'annualShare' && this.values['annualTurnover']) {
                this.setCurrentChoice({ value, name })
                this.jumpToPrevQuestion(2)
            } else {
                this.loading = true
                setTimeout(() => {
                    this.loading = false
                    this.setCurrentChoice({ value, name })
                    if (this.currentQuestion.questionId < this.lastQuestionIndex) {
                        this.nextQuestion()
                    }
                }, this.chatScrollDuration)
            }
            this.trackFormStep(name)
        },
        relevantText(option) {
            if (option.relevantText) {
                var relevantText = this.values[option.relevantText]
                relevantText = relevantText.choice ? relevantText.choice : relevantText
                return this.$i18n.t(`questions:list.${option.questionLabel}.text.${relevantText}`, { returnObjects: true })
            } else {
                return this.$i18n.t(`questions:list.${option.questionLabel}.text`, { returnObjects: true })
            }
        },
        loadTextMessage(isResultCard) {
            const chats = document.querySelectorAll('.chat__item:not(.chat__item--show)')
            if (chats.length > 0) {
                let index = 0
                const that = this
                const timer = setInterval((function chatLoadInterval() {
                    chats[index].className += ' chat__item--show'
                    if (isResultCard) {
                        that.scrollToResultCard(chats[index].parentElement)
                    } else {
                        that.scrollToBottom()
                    }
                    index++
                    if (index >= chats.length) {
                        clearInterval(timer)
                    }
                    return chatLoadInterval
                })(), (this.chatScrollDuration))
            }
        },
        scrollToBottom() {
            setTimeout(() => {
                this.chatBottom && this.chatBottom.scrollIntoView(false)
            }, 100)
        },
        scrollToResultCard(elem) {
            setTimeout(() => {
                if (window.innerWidth < 768) {
                    window.scrollTo({
                        top: elem.offsetTop - 30,
                        behavior: 'smooth'
                    })
                } else {
                    document.querySelector('.wrapper').scrollTo({
                        top: elem.offsetTop + 64,
                        behavior: 'smooth'
                    })
                }
            }, 100)
        },
        jumpToPrevQuestion(index) {
            this.loading = true
            this.goBackToQuestion(index)
            setTimeout(() => {
                this.loading = false
                this.nextQuestion()
            }, this.chatScrollDuration)
        }
    },
    mounted() {
        this.chatBottom = document.querySelector('.chat__bottom')
        this.trackPageView()
        setTimeout(() => {
            this.loadTextMessage()
            document.getElementById('getStarted').focus()
        }, this.chatScrollDuration)
    },
    watch: {
        questionsList(newVal) {
            this.$nextTick(() => {
                this.loadTextMessage()
            })
        },
        result(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.loadTextMessage(true)
                })
            }
        }
    }
}
</script>
